// extracted by mini-css-extract-plugin
module.exports = {"container":"k-0_NDmNO0VXYg2ryWQ6-","visible":"_1o3n9piHnUPeXB4-J-Z_Gj","saveBtn":"_2JWoJwHToJgtzHXGmxsM1o","cancelBtn":"kwDWI2jDQBG5J6wphJH5B","icon":"_3jxv_KJz2mUaDPgSOAtpoL"};